// extracted by mini-css-extract-plugin
export default {"cardContainer":"InstituteBlock_cardContainer__r0PYi","container":"InstituteBlock_container__0MANf"};